export default {
    path : "officebuilding-carrier-recycled",
    name : "officebuilding-carrier-recycled",
    meta : {
        title : "载体回收站"
    },
    component: () => import('@/pages/officebuilding/recycledCarrier/Index'),
    redirect: {
        name : "officebuilding-carrier-recycled-whole"
    },
    children: [
        {
            path: 'all',
            name: 'officebuilding-carrier-recycled-whole',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'recent',
            name: 'officebuilding-carrier-recycled-recent',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'atme',
            name: 'officebuilding-carrier-recycled-atme',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'meat',
            name: 'officebuilding-carrier-recycled-meat',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'reply',
            name: 'officebuilding-carrier-recycled-reply',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'search',
            name: 'officebuilding-carrier-recycled-search',
            meta: {
                title: '写字楼载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/officebuilding/recycledcarrier/index.js